import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home, Terminos, Privacidad, BetaLanding, MetaPage, B2B, PitchPage, FlujoPage, Layout } from './components';
export function AppRouter() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        {/* Landing principal con calculadora simple */}
        <Route path="/" element={<Layout data-id="element-3">
              <Home data-id="element-4" />
            </Layout>} data-id="element-2" />

        {/* Flujo de evaluación completo */}
        <Route path="/flujo" element={<FlujoPage data-id="element-6" />} data-id="element-5" />

        {/* Otras páginas */}
        <Route path="/b2b" element={<Layout data-id="element-8">
              <B2B data-id="element-9" />
            </Layout>} data-id="element-7" />
        <Route path="/pitch" element={<PitchPage data-id="element-11" />} data-id="element-10" />
        <Route path="/terminos" element={<Layout data-id="element-13">
              <Terminos data-id="element-14" />
            </Layout>} data-id="element-12" />
        <Route path="/privacidad" element={<Layout data-id="element-16">
              <Privacidad data-id="element-17" />
            </Layout>} data-id="element-15" />
        <Route path="/beta" element={<Layout data-id="element-19">
              <BetaLanding data-id="element-20" />
            </Layout>} data-id="element-18" />
        <Route path="/meta" element={<MetaPage data-id="element-22" />} data-id="element-21" />

        {/* 404 */}
        <Route path="*" element={<Layout data-id="element-24">
              <div className="flex flex-col items-center justify-center py-24" data-id="element-25">
                <h1 className="text-4xl font-bold mb-4" data-id="element-26">404</h1>
                <p className="text-xl mb-8" data-id="element-27">Página no encontrada</p>
                <a href="/" className="px-6 py-3 bg-[#2B5FD9] text-white font-medium rounded-2xl hover:translate-y-[-2px] transition-transform" data-id="element-28">
                  Volver al inicio
                </a>
              </div>
            </Layout>} data-id="element-23" />
      </Routes>
    </BrowserRouter>;
}